import pb
    from "../../lib/pb";


const COLLECTION =
    "orders";


/*
--------------------------------------------------
CREATE ORDER
--------------------------------------------------
*/

export async function createOrder(
    data
) {

    if (!data) {

        throw new Error(
            "Order data is required."
        );

    }


    return await pb
        .collection(COLLECTION)
        .create(data);

}


/*
--------------------------------------------------
GET ORDER
--------------------------------------------------
*/

export async function getOrder(
    id
) {

    if (!id) {

        throw new Error(
            "Order ID is required."
        );

    }


    return await pb
        .collection(COLLECTION)
        .getOne(id);

}


/*
--------------------------------------------------
GET CUSTOMER ORDERS
--------------------------------------------------
*/

export async function getCustomerOrders(
    userId
) {

    if (!userId) {

        return [];

    }


    return await pb
        .collection(COLLECTION)
        .getFullList({

            sort: "-created",

            filter:
                `buyer="${userId}"`

        });

}


/*
--------------------------------------------------
GET BRAND ORDERS
--------------------------------------------------
*/

export async function getBrandOrders(
    brandId
) {

    if (!brandId) {

        return [];

    }


    return await pb
        .collection(COLLECTION)
        .getFullList({

            sort: "-created",

            filter:
                `brand="${brandId}"`

        });

}


/*
--------------------------------------------------
GET PENDING ORDERS
--------------------------------------------------
*/

export async function getPendingOrders(
    userId
) {

    if (!userId) {

        return [];

    }


    return await pb
        .collection(COLLECTION)
        .getFullList({

            sort: "-created",

            filter:
                `buyer="${userId}" && status="pending"`

        });

}


/*
--------------------------------------------------
GET ORDER BY PAYMENT ID
--------------------------------------------------
*/

export async function getOrderByPaymentId(
    paymentId
) {

    if (!paymentId) {

        throw new Error(
            "Payment ID is required."
        );

    }


    const records =
        await pb
            .collection(COLLECTION)
            .getFullList({

                filter:
                    `paymentId="${paymentId}"`

            });


    return records.length
        ? records[0]
        : null;

}


/*
--------------------------------------------------
UPDATE ORDER
--------------------------------------------------
*/

export async function updateOrder(
    id,
    data
) {

    if (!id) {

        throw new Error(
            "Order ID is required."
        );

    }


    if (!data) {

        throw new Error(
            "Order data is required."
        );

    }


    return await pb
        .collection(COLLECTION)
        .update(
            id,
            data
        );

}


/*
--------------------------------------------------
MARK ORDER PAYMENT PENDING
--------------------------------------------------
*/

export async function markOrderPaymentPending(
    id
) {

    if (!id) {

        throw new Error(
            "Order ID is required."
        );

    }


    return await updateOrder(

        id,

        {

            status:
                "payment_pending",

            paymentStatus:
                "pending"

        }

    );

}


/*
--------------------------------------------------
MARK ORDER PAID
--------------------------------------------------
*/

export async function markOrderPaid(
    id,
    paymentId
) {

    if (!id) {

        throw new Error(
            "Order ID is required."
        );

    }


    if (!paymentId) {

        throw new Error(
            "Payment ID is required."
        );

    }


    return await updateOrder(

        id,

        {

            status:
                "paid",

            paymentStatus:
                "paid",

            paymentId:

                paymentId,

            paidAt:
                new Date()
                    .toISOString()

        }

    );

}


/*
--------------------------------------------------
MARK ORDER PAYMENT FAILED
--------------------------------------------------
*/

export async function markOrderPaymentFailed(
    id
) {

    if (!id) {

        throw new Error(
            "Order ID is required."
        );

    }


    return await updateOrder(

        id,

        {

            status:
                "payment_failed",

            paymentStatus:
                "failed"

        }

    );

}


/*
--------------------------------------------------
MARK ORDER CONFIRMED
--------------------------------------------------
*/

export async function markOrderConfirmed(
    id
) {

    if (!id) {

        throw new Error(
            "Order ID is required."
        );

    }


    return await updateOrder(

        id,

        {

            status:
                "confirmed",

            paymentStatus:
                "paid",

            inventoryStatus:
                "deducted",

            fulfillmentStatus:
                "unfulfilled",

            confirmedAt:
                new Date()
                    .toISOString()

        }

    );

}